module.exports = __webpack_public_path__ + "img/74.714f98af.jpg";